import React from 'react';

import Page from '../components/global/page';

import Hero from '../components/rocks/hero';
import Opener from '../components/rocks/opener';
import Content from '../components/rocks/content';
import Gallery from '../components/rocks/gallery';
import Tiers from '../components/rocks/tiers';
import Details from '../components/lessons/details';
import AllStars from '../components/rocks/allstars';

export default ({ pageContext }) => {
	const {
		title,
		hero,
		opener,
		content,
		gallery,
		tiers,
		details,
		allstars,
	} = pageContext;

	return (
		<Page title={title}>
			<Hero data={hero} />
			<Opener data={opener} />
			<Content data={content} />
			<Gallery data={gallery} />
			<Tiers data={tiers} />
			<Details data={details} />
			<AllStars data={allstars} />
		</Page>
	);
};
